import React from "react";

import "./styles.scss";

const AppHeader = () => {
  return (
    <header className="app-header">
      <span>Dashboard</span>
    </header>
  );
};

export default AppHeader;
